import { writable } from "svelte/store";
import { user, get__store, alert } from '../store.js';
import { Contexts, ContextRequest, ContextsRequest } from "../../proto/task_pb";
import { ContextServicePromiseClient } from "../../proto/task_grpc_web_pb";

export const contexts = writable([]);


export class Contextsvc {
    constructor(deps) {
        this.proto = {
            ContextsRequest,
            ContextRequest,
            Contexts,
            ContextClient: ContextServicePromiseClient,
        }
        this.client = new this.proto.ContextClient(VITE_APIURL, null, null)
        this.refresh()
    }

    setJWT() {
        return {
            ["X-CSRF-Token"]: get__store(user).accessToken,//'localStorage.getItem("X-CSRF-Token")',
        };;
    }

    getContexts() {
        return contexts
    }

    refresh() {
        contexts.set([]);
        try {
        const req = new this.proto.ContextsRequest()
        this.client.index(req, this.setJWT()).then(res => {
            res.getContexts().getContextList().map(context => {
                contexts.update(n => [...n, this.sveltecontextfromproto(context)])
            })
        })
        } catch (e) {
            console.log("Error retrieving contexts", e);
            alert.update((n) => [
                ...n,
                "Failed to retrieve contexts " + e.message,
            ]);            
        }
        return
    }
    completed() {
        const req = new this.proto.ContextRequest()
        return this.client.contextcompleted(req, this.setJWT()).then(res => {
            return res.getContextList()
        })
    }
    add(data) {
        let req = new this.proto.ContextRequest()
        req.setContext(this.protobuffromsveltecontext(data))
        this.client.add(req, this.setJWT()).then(this.refresh())
        return
    }

    update(arguements) {
        arguements.forEach(item => {
          let req = new this.proto.ContextRequest()
          req.setContext(this.protobuffromsveltecontext(item))
          this.client.update(req, this.setJWT()).catch( e => {
                console.log("Error updating context", e);
                alert.update((n) => [
                    ...n,
                    "Failed to update contexts " + e.message,
                ])
          })
        })
        this.refresh();
        return
    }

    sveltecontextfromproto(data) {
        return {
            id: data.getId(),
            name: data.getName(),
            active: data.getActive(),
            //description: data.getDescription(),
            updatedAt: data.getUpdatedAt(),
            createdAt: data.getCreatedAt(),
        }
    }
    protobuffromsveltecontext(data) {
        let tsk = new proto.proto.Context
        tsk.setId(data.id)
        tsk.setName(data.name)
        tsk.setActive(data.active)
        //tsk.setDescription(data.description)
        return tsk
    }
}
